module.exports = __webpack_public_path__ + "img/hero-j-quarter.ab1007cd.jpg";